function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M464.372,373.446H47.628c-8.968,0-16.237,7.269-16.237,16.237c0,8.968,7.269,16.237,16.237,16.237h416.744 c8.968,0,16.237-7.269,16.237-16.237C480.609,380.715,473.34,373.446,464.372,373.446z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M334.478,437.852H177.522c-8.968,0-16.237,7.269-16.237,16.237c0,8.968,7.269,16.237,16.237,16.237h156.956 c8.968,0,16.237-7.269,16.237-16.237C350.715,445.121,343.446,437.852,334.478,437.852z"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M256,176.976c-68.941,0-125.023,56.087-125.023,125.023c0,39.477,18.331,75.961,50.291,100.1 c7.155,5.396,17.33,3.973,22.742-3.177c5.401-7.155,3.983-17.336-3.172-22.742c-23.76-17.936-37.388-44.976-37.388-74.18 c0-51.032,41.517-92.55,92.55-92.55c51.038,0,92.555,41.517,92.555,92.55c0,29.253-13.915,56.937-37.22,74.056 c-7.225,5.309-8.779,15.474-3.475,22.699c3.182,4.33,8.108,6.625,13.098,6.625c3.339,0,6.706-1.028,9.601-3.15 c31.602-23.219,50.464-60.688,50.464-100.23C381.023,233.063,324.941,176.976,256,176.976z"
})));

var _ref5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M256,41.674c-8.968,0-16.237,7.269-16.237,16.237v86.596c0,8.968,7.269,16.237,16.237,16.237s16.237-7.274,16.237-16.237 V57.911C272.237,48.943,264.968,41.674,256,41.674z"
})));

var _ref6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M495.763,281.438h-86.596c-8.968,0-16.237,7.269-16.237,16.237s7.269,16.237,16.237,16.237h86.596 c8.968,0,16.237-7.269,16.237-16.237S504.731,281.438,495.763,281.438z"
})));

var _ref7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M102.833,281.438H16.237C7.269,281.438,0,288.706,0,297.674s7.269,16.237,16.237,16.237h86.596 c8.968,0,16.237-7.269,16.237-16.237S111.801,281.438,102.833,281.438z"
})));

var _ref8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M437.424,116.25c-6.343-6.338-16.616-6.343-22.959,0l-61.159,61.159c-6.343,6.343-6.343,16.621,0,22.964 c3.172,3.166,7.323,4.752,11.479,4.752s8.313-1.586,11.479-4.752l61.159-61.159C443.768,132.871,443.768,122.593,437.424,116.25z"
})));

var _ref9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M158.693,177.409L97.534,116.25c-6.338-6.343-16.621-6.343-22.959,0c-6.343,6.338-6.343,16.621,0,22.959l61.159,61.159 c3.166,3.172,7.323,4.757,11.479,4.757s8.313-1.586,11.479-4.757C165.036,194.03,165.036,183.746,158.693,177.409z"
})));

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var _ref18 = /*#__PURE__*/React.createElement("g", null);

var _ref19 = /*#__PURE__*/React.createElement("g", null);

var _ref20 = /*#__PURE__*/React.createElement("g", null);

var _ref21 = /*#__PURE__*/React.createElement("g", null);

var _ref22 = /*#__PURE__*/React.createElement("g", null);

var _ref23 = /*#__PURE__*/React.createElement("g", null);

var _ref24 = /*#__PURE__*/React.createElement("g", null);

function SvgNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNew);
export default __webpack_public_path__ + "static/media/new.8da1a390.svg";
export { ForwardRef as ReactComponent };